import { createFileRoute } from "@tanstack/react-router";
import { AdminVendorsPage } from "@/components/admin/pages/AdminVendorsPage";

export const Route = createFileRoute("/pulse-ops-x7k2/vendors")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
    city: typeof search.city === "string" ? search.city : undefined,
  }),
  component: AdminVendorsPage,
});
